module.exports = __webpack_public_path__ + "0e25a276f2c15422b60ab8e04be0dbe8.png";